require('Assets/scss/pages/error.scss');
